import FilterSelect, { type FilterOption } from '@/components/base/FilterSelect';
import MarketSelect from '@/components/base/MarketSelect';

interface ReportToolbarProps {
  tabs: FilterOption[];
  tab: string;
  onTab: (id: string) => void;
  period: string;
  onPeriod: (value: string) => void;
  selectedMarkets: string[];
  onSetMarkets: (value: string[]) => void;
  periods: readonly { id: string; label: string }[];
}

export default function ReportToolbar({
  tabs,
  tab,
  onTab,
  period,
  onPeriod,
  selectedMarkets,
  onSetMarkets,
  periods,
}: ReportToolbarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
        <FilterSelect
          value={tab}
          onChange={onTab}
          label="Report"
          className="w-full sm:w-60"
          options={tabs}
        />

        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <div className="relative">
            <span className="sr-only">Reporting period</span>
            <i className="ri-calendar-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400" />
            <select
              value={period}
              onChange={(event) => onPeriod(event.target.value)}
              className="h-9 w-full cursor-pointer appearance-none rounded-md border border-background-300 bg-background-50 pl-8 pr-8 text-sm font-label text-foreground-700 focus:border-primary-400 focus:outline-none sm:w-44"
            >
              {periods.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.label}
                </option>
              ))}
            </select>
            <i className="ri-arrow-down-s-line pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-foreground-500" />
          </div>

          <div className="relative">
            <span className="sr-only">Filter by market</span>
            <MarketSelect
              value={selectedMarkets}
              onChange={onSetMarkets}
              placeholder="All markets"
              compact
              className="sm:w-56"
            />
          </div>
        </div>
      </div>
    </div>
  );
}